import {formatDate} from "./dateHelpers";

export function fetchSignificantDays() {
    return $.ajax({
        url: "/api/significant-days",
        method: "GET"
    });
}

export function buildOnRenderDay(significantDaysMap) {
    return function (el) {
        const date = new Date(parseInt(el.dataset.time, 10));
        const day = date.getDay();

        if (day === 0 || day === 6) {
            el.classList.add("is-weekend");
        }

        const isoDate = formatDate(date, "-");
        const name = significantDaysMap[isoDate];

        if (name) {
            el.classList.add("is-holiday");
            el.title = name;
        }
    };
}
